module.exports = __webpack_public_path__ + "img/code.107e0bc1.svg";